var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDiscount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.818,
    height: 95.877,
    viewBox: "0 0 104.818 95.877",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ffe200;\n      }\n\n      .cls-4 {\n        fill: #666;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-6 {\n        filter: url(#Rectangle_466);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_466",
    x: 0,
    y: 0,
    width: 104.818,
    height: 95.877,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5732",
    "data-name": "Rectangle 5732",
    className: "cls-1",
    width: 39.328,
    height: 39.331
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_110_2",
    "data-name": "Component 110 \\u2013 2",
    transform: "translate(15 11.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    transform: "translate(0 -0.763)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, -15, -10.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466-2",
    "data-name": "Rectangle 466",
    className: "cls-2",
    width: 74.818,
    height: 65.877,
    rx: 25,
    transform: "translate(15 12)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    className: "cls-3",
    cx: 6.775,
    cy: 6.775,
    r: 6.775,
    transform: "translate(63.906 0.763)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    className: "cls-4",
    cx: 7.527,
    cy: 7.527,
    rx: 7.527,
    ry: 7.527,
    transform: "translate(0 55.555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650",
    transform: "translate(18.461 14.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2648",
    "data-name": "Group 2648",
    className: "cls-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    className: "cls-1",
    d: "M35.209,10.654c0,.372,0,.744,0,1.115a3.147,3.147,0,0,0,1,2.417c.5.471.977.96,1.452,1.453a5.7,5.7,0,0,1,.009,8.041c-.5.522-1.016,1.032-1.533,1.537a3.067,3.067,0,0,0-.929,2.27c-.006.724,0,1.448,0,2.172a5.623,5.623,0,0,1-5.531,5.553,18.227,18.227,0,0,0-2.869.076,2.793,2.793,0,0,0-1.534.8c-.514.51-1.02,1.027-1.539,1.532a5.7,5.7,0,0,1-8.126.01c-.491-.477-.981-.956-1.452-1.452a3.109,3.109,0,0,0-2.314-.968c-.7-.011-1.409,0-2.113,0a5.622,5.622,0,0,1-5.611-5.591,17.268,17.268,0,0,0-.077-2.811,2.8,2.8,0,0,0-.8-1.534c-.51-.514-1.027-1.021-1.532-1.539A5.7,5.7,0,0,1,1.7,15.607c.451-.463.9-.931,1.371-1.368a3.267,3.267,0,0,0,1.054-2.575c-.007-.665,0-1.33,0-2A5.619,5.619,0,0,1,9.655,4.118a19.778,19.778,0,0,0,2.811-.066,2.918,2.918,0,0,0,1.678-.892q.719-.733,1.454-1.452A5.7,5.7,0,0,1,23.723,1.7c.477.463.956.927,1.41,1.413a3.206,3.206,0,0,0,2.474,1.012q1,0,2,0a5.606,5.606,0,0,1,5.606,5.591c0,.313,0,.626,0,.939M11.214,32.306a6.1,6.1,0,0,1,5.559,2.313c.257.294.544.563.829.831a2.769,2.769,0,0,0,4.134-.01c.554-.525,1.071-1.088,1.628-1.61a5.3,5.3,0,0,1,3.766-1.522c.744,0,1.488.013,2.231,0A2.757,2.757,0,0,0,32.236,29.9,13.9,13.9,0,0,0,32.3,27.2a5.438,5.438,0,0,1,1.6-3.915c.5-.521,1.032-1.017,1.531-1.542a2.777,2.777,0,0,0-.011-4.177c-.514-.538-1.06-1.044-1.57-1.584a5.323,5.323,0,0,1-1.542-3.818c.006-.724.011-1.448,0-2.172a2.839,2.839,0,0,0-2.956-2.97c-.724-.015-1.448-.009-2.172,0a5.356,5.356,0,0,1-3.865-1.572c-.524-.5-1.02-1.029-1.542-1.53a2.781,2.781,0,0,0-4.218.011c-.536.515-1.043,1.061-1.585,1.57A5.319,5.319,0,0,1,12.2,7.023c-.744,0-1.488-.013-2.231,0a2.832,2.832,0,0,0-2.94,2.926c-.019.723-.012,1.448,0,2.172a5.373,5.373,0,0,1-1.592,3.916c-.5.522-1.031,1.018-1.53,1.542a2.774,2.774,0,0,0,.009,4.176c.514.537,1.059,1.045,1.57,1.584a5.331,5.331,0,0,1,1.542,3.819c-.005.744-.016,1.488,0,2.231a2.832,2.832,0,0,0,2.9,2.912c.43.015.861,0,1.291,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    className: "cls-1",
    d: "M20.928,14.556a4.268,4.268,0,1,1-4.271,4.264,4.208,4.208,0,0,1,4.271-4.264m1.341,4.285a1.432,1.432,0,0,0-1.36-1.361,1.415,1.415,0,0,0-1.33,1.326,1.345,1.345,0,1,0,2.69.036",
    transform: "translate(-5.488 -4.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    className: "cls-1",
    d: "M33.548,31.371a4.268,4.268,0,1,1-4.279,4.257,4.21,4.21,0,0,1,4.279-4.257m1.335,4.271a1.345,1.345,0,1,0-2.691.017,1.447,1.447,0,0,0,1.327,1.326,1.431,1.431,0,0,0,1.364-1.342",
    transform: "translate(-9.644 -10.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    className: "cls-1",
    d: "M31.22,19.284a1.362,1.362,0,0,1,1.368.777,1.417,1.417,0,0,1-.166,1.6c-.261.315-.568.593-.858.883q-4.771,4.773-9.545,9.545a4.9,4.9,0,0,1-.384.363,1.481,1.481,0,0,1-1.977-.11,1.451,1.451,0,0,1-.066-1.975c.5-.552,1.04-1.062,1.566-1.588q4.418-4.421,8.837-8.842a1.581,1.581,0,0,1,1.226-.653",
    transform: "translate(-6.338 -6.352)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDiscount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-discount.fd2817e5fca683ea296212cab008451c.svg";